import { RestClient } from '@/api/rest-client'
import { CustomerPortalBranding } from '@/api/model/customer-portal-branding'

export class CustomerPortalBrandingClient extends RestClient<CustomerPortalBranding> {
    collectionName = 'customer_portal_brandings'
    parseData = CustomerPortalBranding.fromData

    async update(id: string, data: any): Promise<CustomerPortalBranding> {
        try {
            const formData = new FormData()
            Object.keys(data).forEach(key => {
                formData.append(key, data[key])
            })

            await this.client.post(`${this.basePath}/${this.collectionName}/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            return await this.get(id)

        } catch (error) {
            this.handleError(error)
        }
    }
}
